module.exports = __webpack_public_path__ + "83631883.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/007-age.png
// module id = 1465
// module chunks = 4